module.exports = __webpack_public_path__ + "static/img/en_logo.3743e0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/en_logo.jpg
// module id = NGyk
// module chunks = 29